<template>
  <label class="checkbox">
    <input type="checkbox" :checked="value" @change="$emit('input', $event.target.checked)" class="hidden">
    <span class="checkbox-item">
      <CheckboxIcon class="checkbox-icon"/>
    </span>
    <span class="checkbox-text">{{label}}</span>
  </label>
</template>

<script>
  import CheckboxIcon from '@/assets/svg/check.svg';

  export default {
    props: ['name', 'label', 'value'],
    components: {
      CheckboxIcon
    }
  }
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  margin-bottom: 10px;
  cursor: pointer;
  &-icon {
    display: none;
  }
  &-item {
    min-width: 20px;
    max-width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid #bcd1dd;
    background-color: #ffffff;
    margin-right: 15px;
  }
  &-text {
    font-size: 17px;
  }
}
.hidden {
  display: none;
  &:checked + span {
    background-color: #64d282;
    border-color: #64d282;
    display: flex;
    align-items: center;
    justify-content: center;
    & > .checkbox-icon {
      display: block;
    }
  }
}
</style>